import { computed, type Ref } from "vue";

import { Statsig } from "@/env/statsig/client";

import type { CardProps } from "./useCardData";

export function useRevUpCampaign(
  props: CardProps,
  enableRevUpRecert?: Ref<boolean> | boolean
) {
  const isRevUpEnabled = (): boolean => {
    if (enableRevUpRecert !== undefined) {
      return typeof enableRevUpRecert === "boolean"
        ? enableRevUpRecert
        : enableRevUpRecert.value;
    }
    return !!globalThis.env.ENABLE_REV_UP_RECERT;
  };

  const showRevUpRecertCampaign = computed((): boolean => {
    if (!isRevUpEnabled()) return false;

    const campaignGuids = Statsig.getConfig<string[]>(
      "REVUP_CAMPAIGN",
      "REV_UP_CAMPAIGN_GUIDs"
    );
    const start = new Date(
      Statsig.getConfig<string>("REVUP_CAMPAIGN", "REV_UP_CAMPAIGN_START")
    );
    const end = new Date(
      Statsig.getConfig<string>("REVUP_CAMPAIGN", "REV_UP_CAMPAIGN_END")
    );

    const today = new Date().toLocaleString("en-US", {
      timeZone: "America/Los_Angeles",
    });

    const isDCFNDU =
      !!props.result?.guid &&
      Array.isArray(globalThis.env.REV_UP_CAMPAIGN_GUIDS_DCFNDU) &&
      globalThis.env.REV_UP_CAMPAIGN_GUIDS_DCFNDU.includes(props.result.guid) &&
      new Date(today) >=
        new Date(globalThis.env.REV_UP_CAMPAIGN_START_DCFNDU) &&
      new Date(today) <= new Date(globalThis.env.REV_UP_CAMPAIGN_END_DCFNDU);

    return (
      (campaignGuids.includes(props.result?.guid ?? "") &&
        new Date(today) >= start &&
        new Date(today) <= end) ||
      isDCFNDU
    );
  });

  return {
    showRevUpRecertCampaign,
  };
}
